// src/api/auth.js
import apiClient from './client';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Login user
export const login = async (username, password) => {
  try {
    // Using direct axios for login to avoid auth header
    const response = await axios.post(`${API_URL}/auth/login/json`, {
      username,
      password,
    });
    
    if (response.data && response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
    }
    
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Register user
export const register = async (userData) => {
  try {
    // Using direct axios for register to avoid auth header
    const response = await axios.post(`${API_URL}/users`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get current user
export const getCurrentUser = async () => {
  try {
    const response = await apiClient.get('/auth/me');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Logout user
export const logout = () => {
  localStorage.removeItem('token');
  // Optional: Call a logout endpoint if your API requires it
};

// Refresh token function (to be implemented if needed)
export const refreshAuthToken = async () => {
  // Implement token refresh logic here
  // This would call your backend's refresh token endpoint
  throw new Error('Token refresh not implemented');
};

export default {
  login,
  register,
  getCurrentUser,
  logout,
};